import React, { useEffect, useState, useCallback } from 'react'
import { ERCText } from 'components/text'
import { ERCButton } from 'components/button'
import { Box } from '@mui/material'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Header from 'components/store/header'
import { StoreCard } from 'components/store/card'
import Layout from 'partials/layout'
import { useNavigate, useParams } from 'react-router-dom'
import { apiRequest } from 'services'
import { useDispatch, useSelector } from 'react-redux'
import { setProductDetails } from 'store/reducers/products'
import { FiMinus } from "react-icons/fi";
import { HiPlus } from "react-icons/hi2";
import { GoEye } from "react-icons/go";
import { addToCart, removeFromCart, clearCart, updateItemQuantity } from 'store/reducers/cart'
import { toast } from 'react-toastify'
import { productSaved } from 'store/reducers/products'
import { baseURL } from 'services';
import { showModal, closeModal } from 'store/reducers/modal'
import Shoppingcartmodal from 'components/modal/shoppingcartmodal/shoppingcartmodal'


const Productdetails = () => {
const navigate = useNavigate()

  const [tabValue, setTabValue] = useState('1');
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
};
    const dispatch = useDispatch();

const {id} = useParams()

//   const [isAddedToCart, setIsAddedToCart] = useState(false)



useEffect(() => {
    productDetails(); 
}, [id]);

const productDetails = async () => {
    try {
        const data = await apiRequest({
            method: 'get',
            url: `/product/${id}`
        });
        dispatch(setProductDetails(data.data.details));
        // setProductId(data?.data?.details);

        
        console.log(data)
    } catch (error) {
        console.error('Error fetching product details:', error);
    } finally {
        // setLoading(false);
    }
};

// fetching all the product down
const products = useSelector((state) => state.product.data.product);
console.log(products)

//  reference to a particular product
const productId = useSelector((state) => state.product.productDetails);
    console.log("product", productId)



    const discountedPrice = productId?.price - (productId?.price * productId?.discount / 100);
    const price = discountedPrice

    const [isInCart, setIsInCart] = useState(() => {
    // Retrieve cart items from local storage or state
    const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    return cartItems.some(item => item.id === productId?.id);
    });


const [quantity, setQuantity] = useState(1)
const handleDecrease = () => {
    if(quantity > 1) {
        setQuantity(prevState => prevState - 1)
        toast.success("quantity decreased")
    }
}

const handleIncrease = () => {
    setQuantity(prevState => prevState + 1)
    toast.success("quantity Increase", {
      // position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

}




const handleAddToCart = () => {
    const newProduct = {
      id: productId?.id,
      name: productId?.name,
      price: productId?.price,
      quantity: quantity,
      description: productId?.description,
      category: productId?.category,
      discountedPrice: discountedPrice,
      discount: `${productId?.discount}%`,
      image: productId?.productImage,
  };

  dispatch(addToCart(newProduct));
  // Update cart status in local storage
  const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
  cartItems.push(newProduct);
  localStorage.setItem('cartItems', JSON.stringify(cartItems));

  // Update isInCart state to reflect the addition
  setIsInCart(true);
  toast.success("Item added to cart!");
    // Update cart status
    // const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    // cartItems.push({
    //     id: productId?.id,
    //     name: productId?.name,
    //     price: productId?.price,
    //     quantity: quantity,
    // });
    // localStorage.setItem('cartItems', JSON.stringify(cartItems));
    // setIsInCart(true);
    // toast.success("Item added to cart!");
};

// Recheck if the current product is in the cart when productId changes
useEffect(() => {
  const cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
  setIsInCart(cartItems.some(item => item.id === productId?.id));
}, [productId]); // Dependency array includes productId to recheck when it changes



const handleRemoveFromCart = () => {
    dispatch(removeFromCart({
        id: productId?.id,
        name: productId?.name,
        price: productId?.price,
        quantity: quantity,
    }));

    // Update cart status
    let cartItems = JSON.parse(localStorage.getItem('cartItems')) || [];
    cartItems = cartItems.filter(item => item.id !== productId?.id);
    localStorage.setItem('cartItems', JSON.stringify(cartItems));
    setIsInCart(false);
    toast.success("Item removed from cart!");
};

  const items = useSelector(state => state.cart.items);
  console.log(items)

  const handleViewDetails = (id) => {
    navigate(`/product-details/${id}`);
    window.scrollTo(0,0);
    }

    const token = useSelector((state) => state?.user?.data?.user?.data?.token);

    const SavedProductBadToken = () => {
      const handleCloseModal = () => {
          dispatch(closeModal());
        };
    
        dispatch(showModal({
          content: <Shoppingcartmodal onClose={handleCloseModal} />
        }));
  }

    const saveProductByID = async (id) => {
      try {
          const data = {
              productId: id
            }
            
          const response = await fetch(`${baseURL}/product/save`, {
              body: JSON.stringify(data),
              method: "POST",
              headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json"
              }
          })
          const result = await response.json()
          // toast.success("Fetched Saved Product")
          // console.log('Product saved successfully:', result.status);
          if(result.status === 'success')
              {
                  toast.success(result?.data?.message)
                  productSaved((prev) => [...prev, result.data]);
              } else if ( result.status === 'failed' && result.message === "Authorization denied! Token expired"){
          console.log('Error:', result.status);
                  toast.error(result.message || "something went wrong!") 
                  // navigate("/store-login-student")
                  SavedProductBadToken()
              } else {
                  console.log(result)
              }
      
      } catch (error) {
  
              } finally {
          // Any final steps
      }
  };

  return (
    <Layout>
    
      <Header/>
      <div className="px-4 md:px-10 lg:px-20">
      <div
        className="flex items-center gap-2 cursor-pointer py-3"
        onClick={() => {
          window.scrollTo(0, 0);
          navigate("/store");
        }}
      >
        <img src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721893028/ERC/drowdown-arrow_suwan5.svg" />
        <p>Go Back</p>
      </div>

      <div className="w-full flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-32 mt-10">
        <div>
          <img
            className="h-24 md:h-28 lg:h-32"
            src={productId.productImage}
            alt="small-pics"
          />
        </div>
        <div className="w-full max-w-lg">
          <img
            className="w-full h-auto object-contain"
            src={productId?.productImage}
            alt="big_img"
          />
        </div>
        <div className="flex flex-col gap-6 w-full max-w-lg">
          <ERCText size="28px" weight="700" lHeight="40px">
            {productId.name}
          </ERCText>
          <p>{productId.description}</p>
          <div className="flex gap-6">
            <div className="flex items-center justify-center gap-4 w-44 bg-gray-200 h-12">
              <FiMinus className="cursor-pointer" onClick={handleDecrease} />
              <ERCText size="16px" weight="600" lHeight="26px">
                {quantity}
              </ERCText>
              <HiPlus className="cursor-pointer" onClick={handleIncrease} />
            </div>
            <div
              onClick={() => saveProductByID(id)}
              className="flex gap-4 justify-center items-center bg-gray-200 w-44 cursor-pointer"
            >
              <GoEye />
              <p>Add to Wishlist</p>
            </div>
          </div>
          <ERCText size="28px" weight="700" lHeight="40px">
            {price * quantity}
          </ERCText>
          <div className="flex gap-6 mt-8">
            <ERCButton
              width="230px"
              size="16px"
              weight="600"
              lHeight="24px"
              outlineColor="#F5BF55"
              bgcolor="none"
              color="#00296B"
              onClick={handleRemoveFromCart}
            >
              Remove From Cart
            </ERCButton>
            {!isInCart && (
              <ERCButton
                width="230px"
                size="16px"
                weight="600"
                lHeight="24px"
                outlineColor="#F5BF55"
                bgcolor="none"
                color="#00296B"
                onClick={handleAddToCart}
              >
                Add To Cart
              </ERCButton>
            )}
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center mt-20">
        <div className="w-full max-w-4xl mx-auto">
          <TabContext value={tabValue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChange}
                aria-label="basic tabs example"
                TabIndicatorProps={{ style: { backgroundColor: "black" } }}
              >
                <Tab label="Additional Information" value="1" sx={{ "&.Mui-selected": { color: "black" } }} />
              </TabList>
            </Box>
            <TabPanel value="1">
              <ERCText size="16px" weight="400" color="#25252E">
                {productId?.description}
              </ERCText>
            </TabPanel>
          </TabContext>
        </div>

        <p className="text-gray-800 font-manrope text-2xl font-semibold py-4 mt-8">
          Recommended For You
        </p>

        <div className="w-full max-w-5xl flex flex-wrap gap-8 justify-center mb-32">
          {products.length > 0 ? (
            products.slice(0, 4).map((product) => (
              <StoreCard
                key={product?.id}
                title={product?.name}
                slashPrice={`NGN ${product?.price}`}
                discount={`-${product.discount}%`}
                amount={`NGN ${product.price - product.price * (product.discount / 100)}`}
                number={"1000"}
                img={product.productImage[0]}
                viewDetails={"View Details"}
                onClick={() => handleViewDetails(product?.id)}
              />
            ))
          ) : (
            <p className="text-2xl">No products available</p>
          )}
        </div>
      </div>
    </div>
    </Layout>
  )
}

export default Productdetails
